import { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
// @mui
import { Box, Collapse, List, ListItemText } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

/**
 * Verifica il permesso associato alla voce: `auth` falsy = sempre visibile,
 * altrimenti la voce compare solo se il flag è presente in userData.
 */
function isAllowed(auth) {
  if (!auth) return true;

  const data = JSON.parse(localStorage.getItem('userData'));
  return Boolean(data && data[auth]);
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info, auth, children } = item;
  const { pathname } = useLocation();

  // Una voce con sottovoci è aperta di default quando ci si trova su una di esse.
  const hasChildren = Array.isArray(children) && children.length > 0;
  const childActive = hasChildren && children.some((child) => pathname === child.path);
  const [open, setOpen] = useState(childActive);

  const active = isAllowed(auth);

  if (hasChildren) {
    const visibleChildren = children.filter((child) => isAllowed(child.auth));

    return (
      <>
        <StyledNavItem
          onClick={() => setOpen((prev) => !prev)}
          sx={{ display: active ? 'flex' : 'none' }}
        >
          <StyledNavItemIcon sx={{ color: '#919eab' }}>{icon && icon}</StyledNavItemIcon>

          <ListItemText sx={{ color: '#919eab' }} disableTypography primary={title} />

          <Box sx={{ display: 'flex', color: '#919eab', pr: 1 }}>
            {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </Box>
        </StyledNavItem>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List disablePadding>
            {visibleChildren.map((child) => (
              <StyledNavItem
                key={child.title}
                component={RouterLink}
                to={child.path}
                end
                sx={{
                  pl: 5,
                  height: 40,
                  '&.active': { color: 'text.primary', bgcolor: 'action.selected', fontWeight: 'fontWeightBold' },
                }}
              >
                <ListItemText sx={{ color: '#919eab' }} disableTypography primary={child.title} />
              </StyledNavItem>
            ))}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },

        display: active ? 'flex' : 'none',
      }}
    >
      <StyledNavItemIcon sx={{ color: '#919eab' }}>{icon && icon}</StyledNavItemIcon>

      <ListItemText sx={{ color: '#919eab' }} disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
